<template>
  <div class="usp">
    <h3 class="usp-title">
      {{ uspTitle }}
    </h3>
    <div class="usp-container">
      <ul
        v-if="uspListLeft && uspListLeft.length > 0"
        class="usp-list-left"
      >
        <li
          v-for="(list, index) in uspListLeft"
          :key="index"
          class="usp-list-item"
          :class="{ 'has-no-padding': !uspShowIcons}"
        >
          <KfImage
            v-if="uspShowIcons && list.image"
            :src="list.image"
            class="icon image"
          />
          <Checkmark
            v-else-if="uspShowIcons"
            class="icon"
          />
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="usp-list-item-content"
            v-html="list.item"
          />
          <!-- eslint-enable vue/no-v-html -->
        </li>
      </ul>
      <ul
        v-if="uspListRight && uspListRight.length > 0"
        class="usp-list-right"
      >
        <li
          v-for="(list, index) in uspListRight"
          :key="index"
          class="usp-list-item"
        >
          <KfImage
            v-if="uspShowIcons && list.image"
            :src="list.image"
            class="icon image"
          />
          <Checkmark
            v-else-if="uspShowIcons"
            class="icon"
          />
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="usp-list-item-content"
            v-html="list.item"
          />
          <!-- eslint-enable vue/no-v-html -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import KfImage from '@/components/base/image/Image.vue';

export default {
  name: 'KfUspList',
  components: {
    KfImage,
    Checkmark: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Checkmark.vue'),
  },
  props: {
    uspTitle: {
      type: String,
      default: null,
    },
    uspListLeft: {
      type: Array,
      default: null,
    },
    uspListRight: {
      type: Array,
      default: null,
    },
    uspShowIcons: {
      type: Boolean,
      default: true,
    }
  },
};
</script>


<style lang="postcss">
.usp {
  @apply flex flex-col;

  &-container {
    @apply flex flex-col;

    @screen md {
      @apply flex-row justify-between gap-6;
    }
  }

  &-title {
    @apply text-center text-black;
  }

  &-list {
    &-item {
      @apply relative flex leading-xl  items-center gap-6 mb-2;

      &.has-no-padding {
        @apply pl-0;
      }

      .icon {
        @apply w-5 h-5 text-secondary-charlie min-w-[20px] min-h-[20px];

        &.image {
          @apply w-10 h-10 min-w-[40px] min-h-[40px];

          @screen md {
            @apply w-16 h-16 min-w-[64px] min-h-[64px];
          }

          .usp-list-item & {
            @apply p-4;
          }
        }
      }
    }

    &-item-content > * {
      margin-bottom: 0;
    }
  }

}
</style>






